import { Expose, Type, Transform } from 'class-transformer';
import { SurveyRatingElementOptions } from './rating-options';
import { SurveyElement } from './element';
import { SurveyTextareaFieldElement } from './textarea-field-element';
import { COMPONENT_TYPES } from '@/models/enums/component-types.enum';
import { SurveyElementsUnion } from '@/models/survey-elements-union';

export class Elements {
  @Type(() => SurveyElement, {
    discriminator: {
      property: 'element_type',
      subTypes: [
        {
          value: SurveyTextareaFieldElement,
          name: COMPONENT_TYPES.TEXTAREA_FIELD,
        },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  elements!: SurveyElementsUnion[];
}

export class SurveyRating5StarsElement extends SurveyElement {
  @Expose({ name: 'question' })
  title!: string;

  @Expose()
  @Type(() => SurveyRatingElementOptions)
  options!: SurveyRatingElementOptions[];

  @Expose()
  isSubmitable?: boolean;

  @Expose({ name: 'additional_text_area_elements' })
  @Type(() => SurveyTextareaFieldElement)
  additionalTextAreaElements!: SurveyTextareaFieldElement[];

  @Expose()
  @Transform(({ obj: { additional_text_area_elements } }) => {
    return !!additional_text_area_elements.length;
  })
  customValidation?: boolean;
}
